import { styled } from "@mui/material/styles";
import MuiSnackbar, { SnackbarProps } from "@mui/material/Snackbar";

interface CustomSnackbarProps extends SnackbarProps {
  // Add any additional props if needed
}

const Snackbar = styled(MuiSnackbar)<CustomSnackbarProps>(({ theme }) => ({}));

export default Snackbar;
